/**
 * The slice of WebSocket this package actually uses.
 *
 * Declared structurally rather than imported from `lib.dom` because the same state
 * machine runs in three places with three different globals: a browser, React
 * Native's Hermes runtime, and the Node process the tests run in. Depending on the
 * DOM declaration would make the package uncompilable in the app that needs it most.
 *
 * It is also what makes the reconnection rules testable without jsdom — the tests
 * pass in a plain object and drive the handlers by hand, so a timing rule is
 * asserted directly rather than inferred from a real connection.
 */
/**
 * `readyState` when the connection is established.
 *
 * The numeric literal from RFC 6455, written here because the `WebSocket.OPEN`
 * constant hangs off the global class this package deliberately does not name.
 */
export const SOCKET_OPEN = 1;
/**
 * The ambient WebSocket, in whichever runtime this is.
 *
 * Resolved lazily, at connect time rather than at module load: React Native
 * installs its WebSocket during bridge startup, and reading it while the module
 * graph is still evaluating can capture `undefined`.
 */
export function defaultSocketFactory(url, protocols) {
    const ctor = globalThis.WebSocket;
    if (ctor === undefined) {
        throw new Error("No WebSocket implementation is available in this runtime. Pass `createSocket` explicitly.");
    }
    return protocols === undefined ? new ctor(url) : new ctor(url, protocols);
}
//# sourceMappingURL=socket.js.map